// Same-window CustomEvent bridge with the PV web client (exit hand-back contract).
// PV → widget: member confirmed exit in the PV dialog; widget starts the exit flow.
export const SURVEY_EXIT_CONFIRM_EVENT = 'aytm-survey:exit-confirm'
// Widget → PV: exit flow resolved (feedback collected or skipped); PV tears the session down.
export const SURVEY_FEEDBACK_DONE_EVENT = 'aytm-survey:feedback-done'
